import React, { FC, useState } from "react";
import { Container } from "react-bootstrap";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import * as xlsx from "xlsx";
import "react-toastify/dist/ReactToastify.css";

const notifydata: any = {
  position: "top-center",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
};

const BulkQsAdd: FC = () => {
  const [excelData, setExcelData] = useState<any[]>([]);
  const [loader, setLoader] = useState(false);

  const headers = {
    "x-access-token": localStorage.getItem("jwttoken") || "",
    "Content-Type": "application/json",
  };

  const readExcel = async (e: any) => {
    const file = e.target.files[0];
    const data = await file.arrayBuffer();
    const workbook = xlsx.read(data);
    const sheet = workbook.Sheets[workbook.SheetNames[0]];
    const json = xlsx.utils.sheet_to_json(sheet);
    setExcelData(json);
  };

  const uploadAllQuestions = async () => {
    if (excelData.length === 0) {
      toast.error("Please upload a valid Excel file first!", notifydata);
      return;
    }

    try {
      setLoader(true);
      const payload = {
        questions: excelData.map((item: any) => ({
          subject_id: item.subject_id || "",
          question: item.question || item.Questions || "",
          answer1: item.answer1 || item.Answer1 || "",
          answer2: item.answer2 || item.Answer2 || "",
          answer3: item.answer3 || item.Answer3 || "",
          answer4: item.answer4 || item.Answer4 || "",
          answer5: item.answer5 || "", // optional
          correctanswer: item.correctanswer || item.Answer || "",
        })),
      };

      const url = `${process.env.REACT_APP_API_URL}questions/bulk-upload-questions`;
      await axios.post(url, payload, { headers });

      toast.success("Questions uploaded successfully!", notifydata);
      setExcelData([]);
    } catch (error) {
      toast.error("Upload failed. Check data or server logs.", notifydata);
    } finally {
      setLoader(false);
    }
  };

  return (
    <Container className="content mt-4">
      <h3>Bulk Upload Questions</h3>
      <label className="form-label">Upload Excel File</label>
      <input
        type="file"
        className="form-control"
        accept=".xlsx, .xls"
        onChange={readExcel}
      />

      {excelData.length > 0 && (
        <>
          <button
            className="btn btn-primary mt-3"
            onClick={uploadAllQuestions}
            disabled={loader}
          >
            {loader ? "Uploading..." : "Upload All Questions"}
          </button>

          <table className="table table-bordered table-sm mt-4">
            <thead>
              <tr>
                <th>#</th>
                <th>Question</th>
                <th>Answer1</th>
                <th>Answer2</th>
                <th>Answer3</th>
                <th>Answer4</th>
                <th>Correct Answer</th>
              </tr>
            </thead>
            <tbody>
              {excelData.map((item, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{item.question || item.Questions}</td>
                  <td>{item.answer1 || item.Answer1}</td>
                  <td>{item.answer2 || item.Answer2}</td>
                  <td>{item.answer3 || item.Answer3}</td>
                  <td>{item.answer4 || item.Answer4}</td>
                  <td>{item.correctanswer || item.Answer}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
      <ToastContainer />
    </Container>
  );
};

export default BulkQsAdd;
